import moment from 'moment'
import { OperatingTime } from '../definition'

export const date2TimeSlot = (startDate: Date, endDate: Date): string[] => {
  return [`${startDate.getHours()}:${startDate.getMinutes()}`, `${endDate.getHours()}:${endDate.getMinutes()}`]
}

export const timeSlotToDate = (
  date: Date,
  timeSlotBegin: string,
  timeSlotEnd: string
): {
  dateStart: Date
  dateEnd: Date
} => {
  const dateString = moment(date).format('DD/MMM/YYYY')

  const timeSlotBeginAt = moment(`${dateString} ${timeSlotBegin}`, 'DD/MMM/YYYY hh:mmA')
  const timeSlotEndAt = moment(`${dateString} ${timeSlotEnd}`, 'DD/MMM/YYYY hh:mmA')

  return {
    dateStart: timeSlotBeginAt.toDate(),
    dateEnd: timeSlotEndAt.toDate()
  }
}

export const toMonthName = (month?: number) => {
  if (!month) {
    return 'N/A'
  }
  const map = new Map([
    [1, 'January'],
    [2, 'February'],
    [3, 'March'],
    [4, 'April'],
    [5, 'May'],
    [6, 'June'],
    [7, 'July'],
    [8, 'August'],
    [9, 'September'],
    [10, 'October'],
    [11, 'November'],
    [12, 'December']
  ])

  return map.get(month) || 'N/A'
}

export const getDay = (day: number) => {
  if (day === 1) return 'Mon'
  if (day === 2) return 'Tue'
  if (day === 3) return 'Wed'
  if (day === 4) return 'Thu'
  if (day === 5) return 'Fri'
  if (day === 6) return 'Sat'
  if (day === 7) return 'Sun'
}

export const getDayFull = (day: number) => {
  if (day === 0) return 'Monday'
  if (day === 1) return 'Tuesday'
  if (day === 2) return 'Wednesday'
  if (day === 3) return 'Thursday'
  if (day === 4) return 'Friday'
  if (day === 5) return 'Saturday'
  if (day === 6) return 'Sunday'
}

export const getWeekDayLabel = (startWeek: string) => {
  const weekLabel: any = {}

  ;[7, 1, 2, 3, 4, 5, 6].forEach((dayIndex, index) => {
    if (index !== 0) {
      weekLabel[dayIndex] = moment(startWeek).add(index, 'day').format('DD')
    } else {
      weekLabel[dayIndex] = moment(startWeek).format('DD')
    }
  })
  return weekLabel
}

export function get12From24Operation(data: OperatingTime[]) {
  return data.map((day) => {
    if (!day.enable) return day

    const convert = (time12h: any) => {
      const [time, modifier] = time12h.match(/(\d{1,2}:\d{2})(AM|PM)/i)?.slice(1, 3)
      let [hours, minutes] = time.split(':').map(Number)

      if (modifier.toUpperCase() === 'PM' && hours !== 12) {
        hours += 12
      } else if (modifier.toUpperCase() === 'AM' && hours === 12) {
        hours = 0
      }

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`
    }

    return {
      ...day,
      begin: convert(day.begin),
      end: convert(day.end),
      lastBookingSlot: convert(day.lastBookingSlot)
    }
  })
}

export function convertTo12HourFormat(data: OperatingTime[]) {
  return data.map((day) => {
    if (!day.enable) return day

    const convert = (time24h: any) => {
      let [hours, minutes] = time24h.split(':').map(Number)

      const modifier = hours >= 12 ? 'PM' : 'AM'

      hours = hours % 12 || 12

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}${modifier}`
    }

    return {
      ...day,
      begin: convert(day.begin),
      end: convert(day.end),
      lastBookingSlot: convert(day.lastBookingSlot)
    }
  })
}

export const getDayNumberFromString = (day: string) => {
  if (day === 'Monday') return 1
  if (day === 'Tuesday') return 2
  if (day === 'Wednesday') return 3
  if (day === 'Thursday') return 4
  if (day === 'Friday') return 5
  if (day === 'Saturday') return 6
  if (day === 'Sunday') return 7
}
